import { render, staticRenderFns } from "./userActions.vue?vue&type=template&id=5cd63b25&scoped=true"
import script from "./userActions.vue?vue&type=script&lang=js"
export * from "./userActions.vue?vue&type=script&lang=js"
import style0 from "./userActions.vue?vue&type=style&index=0&id=5cd63b25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd63b25",
  null
  
)

export default component.exports